/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantages_DescriptionInputs */

const en_why_listening_advantages_description = /** @type {(inputs: Why_Listening_Advantages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything students and researchers need from a reader, in one app.`)
};

const es_why_listening_advantages_description = /** @type {(inputs: Why_Listening_Advantages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que estudiantes e investigadores necesitan de un lector, en una sola app.`)
};

/**
* | output |
* | --- |
* | "Everything students and researchers need from a reader, in one app." |
*
* @param {Why_Listening_Advantages_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantages_description = /** @type {((inputs?: Why_Listening_Advantages_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantages_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantages_description(inputs)
	return en_why_listening_advantages_description(inputs)
});